/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SponsoredGuildCompetitionWithWinners } from './SponsoredGuildCompetitionWithWinners';
import {
    SponsoredGuildCompetitionWithWinnersFromJSON,
    SponsoredGuildCompetitionWithWinnersFromJSONTyped,
    SponsoredGuildCompetitionWithWinnersToJSON,
    SponsoredGuildCompetitionWithWinnersToJSONTyped,
} from './SponsoredGuildCompetitionWithWinners';
import type { SponsoredGuildCompetition } from './SponsoredGuildCompetition';
import {
    SponsoredGuildCompetitionFromJSON,
    SponsoredGuildCompetitionFromJSONTyped,
    SponsoredGuildCompetitionToJSON,
    SponsoredGuildCompetitionToJSONTyped,
} from './SponsoredGuildCompetition';

/**
 * 
 * @export
 * @interface GetCompetitionInfoResponse
 */
export interface GetCompetitionInfoResponse {
    /**
     * 
     * @type {SponsoredGuildCompetition}
     * @memberof GetCompetitionInfoResponse
     */
    currentCompetition?: SponsoredGuildCompetition;
    /**
     * 
     * @type {SponsoredGuildCompetitionWithWinners}
     * @memberof GetCompetitionInfoResponse
     */
    lastCompetition?: SponsoredGuildCompetitionWithWinners;
}

/**
 * Check if a given object implements the GetCompetitionInfoResponse interface.
 */
export function instanceOfGetCompetitionInfoResponse(value: object): value is GetCompetitionInfoResponse {
    return true;
}

export function GetCompetitionInfoResponseFromJSON(json: any): GetCompetitionInfoResponse {
    return GetCompetitionInfoResponseFromJSONTyped(json, false);
}

export function GetCompetitionInfoResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCompetitionInfoResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'currentCompetition': json['currentCompetition'] == null ? undefined : SponsoredGuildCompetitionFromJSON(json['currentCompetition']),
        'lastCompetition': json['lastCompetition'] == null ? undefined : SponsoredGuildCompetitionWithWinnersFromJSON(json['lastCompetition']),
    };
}

export function GetCompetitionInfoResponseToJSON(json: any): GetCompetitionInfoResponse {
    return GetCompetitionInfoResponseToJSONTyped(json, false);
}

export function GetCompetitionInfoResponseToJSONTyped(value?: GetCompetitionInfoResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentCompetition': SponsoredGuildCompetitionToJSON(value['currentCompetition']),
        'lastCompetition': SponsoredGuildCompetitionWithWinnersToJSON(value['lastCompetition']),
    };
}

